import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, Sparkles, Droplets, Crown } from 'lucide-react';
const services = [{
  icon: <Scissors className="w-6 h-6" data-id="element-201" />,
  title: 'Signature Cuts & Styling',
  description: 'Precision cutting tailored to your face shape and lifestyle, finished with our signature glamorous blowout.',
  price: 'From $150'
}, {
  icon: <Droplets className="w-6 h-6" data-id="element-202" />,
  title: 'Custom Color & Balayage',
  description: 'Dimensional color, seamless balayage, and color correction using premium, hair-healthy products.',
  price: 'From $250'
}, {
  icon: <Crown className="w-6 h-6" data-id="element-203" />,
  title: 'Luxury Extensions',
  description: 'Flawless, undetectable extensions for instant length and volume. Consultation required.',
  price: 'Upon Request'
}, {
  icon: <Sparkles className="w-6 h-6" data-id="element-204" />,
  title: 'Red Carpet & Bridal',
  description: 'Camera-ready styling for your most important events. On-location services available.',
  price: 'From $300'
}];
export function Services() {
  return <section className="py-24 bg-brand-light relative" data-id="element-205">
      <div className="container mx-auto px-6 md:px-12" data-id="element-206">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-207">
          <h2 className="text-brand-purple font-semibold tracking-widest uppercase text-sm mb-3" data-id="element-208">
            Our Offerings
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-209">
            Luxury Services
          </h3>
          <p className="text-gray-600 font-light text-lg" data-id="element-210">
            Elevate your look with our comprehensive menu of high-end hair
            services, designed to bring out your inner star.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-211">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 md:p-10 border border-brand-purple/10 hover:border-brand-gold/50 transition-colors group relative overflow-hidden" data-id="element-212">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-light rounded-bl-full -z-10 transition-transform group-hover:scale-110" data-id="element-213" />

              <div className="w-12 h-12 bg-brand-purple text-brand-gold flex items-center justify-center mb-6" data-id="element-214">
                {service.icon}
              </div>
              <h4 className="text-2xl font-serif text-brand-dark mb-3" data-id="element-215">
                {service.title}
              </h4>
              <p className="text-gray-600 font-light mb-6 line-clamp-3" data-id="element-216">
                {service.description}
              </p>
              <div className="text-brand-purple font-semibold tracking-wide" data-id="element-217">
                {service.price}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}